import { render, staticRenderFns } from "./applyKcode.vue?vue&type=template&id=4ff3a2db&scoped=true"
import script from "./applyKcode.vue?vue&type=script&lang=js"
export * from "./applyKcode.vue?vue&type=script&lang=js"
import style0 from "./applyKcode.vue?vue&type=style&index=0&id=4ff3a2db&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3a2db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff3a2db')) {
      api.createRecord('4ff3a2db', component.options)
    } else {
      api.reload('4ff3a2db', component.options)
    }
    module.hot.accept("./applyKcode.vue?vue&type=template&id=4ff3a2db&scoped=true", function () {
      api.rerender('4ff3a2db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/baseInfo/printSetting/electronicFaceAccount/applyKcode.vue"
export default component.exports